import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from 'react-router';

import SearchIcon from '~/assets/icons/Search';
import VectorIcon from '~/assets/icons/Vector';

export default {
  Mobile,
  SearchForm
};

export function Mobile() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button className="flex" onClick={() => setIsOpen((o) => !o)}>
        <SearchIcon stroke="white" />
      </button>
      {isOpen && (
        <div className="absolute left-0 top-0 z-[1000] flex w-full flex-row items-center bg-black px-5 py-3 lg:hidden">
          <SearchForm onSubmit={() => setIsOpen(false)} />
          <button
            onClick={() => setIsOpen(false)}
            className="flex h-full w-12 items-center justify-center"
          >
            <VectorIcon width="14px" height="14px" fill="white" />
          </button>
        </div>
      )}
    </>
  );
}

function SearchForm({ onSubmit }: { onSubmit?: () => void }) {
  const { t } = useTranslation();

  return (
    <Form
      method="get"
      action="/release-dates/"
      className="relative flex w-full gap-2"
      onSubmit={onSubmit}
    >
      <div className="absolute left-3 top-[13px]">
        <SearchIcon width={18} height={18} />
      </div>
      <input
        type="search"
        name="q"
        placeholder={t('search')}
        required
        className="w-full rounded-lg p-2.5 pl-10 lg:w-48"
      />
    </Form>
  );
}
